import HttpClient from '../services/HttpClient'
import { parchmentConfirm } from '../features/adventure/shared/parchmentConfirm'

/** Misma copia que el backend (`server/utils/statsReallocGate.js`). */
export const STATS_REALLOC_BLOCK_MESSAGE =
  'Se han hecho cambios en las estadísticas de la ficha de personaje y se han reseteado los puntos. Necesitas repartir tus 30 puntos para poder seguir roleando'

export function characterNeedsStatsRealloc(character) {
  if (!character || typeof character !== 'object') return false
  if (character.academyMode === true || Number(character.academy_mode) === 1) return false
  if (character.isMissionIssuer === true || Number(character.is_mission_issuer) === 1) return false
  if (character.isSceneNpc === true || Number(character.is_scene_npc) === 1) return false
  return (
    character.statsReallocPending === true ||
    Number(character.stats_realloc_pending) === 1
  )
}

export function characterFichaPath(character) {
  const slug = character?.slug ? String(character.slug).trim() : ''
  return slug ? `/personajes/${encodeURIComponent(slug)}/ficha` : '/personajes'
}

/**
 * Diálogo pergamino: aviso + CTA a la ficha. No abre el editor.
 */
export function showStatsReallocBlocked(character, navigate) {
  parchmentConfirm({
    title: 'Atributos por repartir',
    message: STATS_REALLOC_BLOCK_MESSAGE,
    cancelLabel: 'Cerrar',
    confirmLabel: 'Ir a mi ficha',
    tone: 'default',
    onConfirm: () => {
      if (typeof navigate === 'function') {
        navigate(characterFichaPath(character))
      }
    },
  })
}

/**
 * Refresca el PJ activo y, si tiene realloc pendiente, muestra el aviso y no deja continuar.
 * @returns {Promise<boolean>} true si puede roleando; false si está bloqueado
 */
export async function ensureStatsReadyForRoleplay({
  character = null,
  navigate,
  setCharacter = null,
} = {}) {
  let char = character
  try {
    const res = await HttpClient().get('/api/v1/characters/init')
    const data = res?.data
    if (data?.characterId) {
      char = data
      if (typeof setCharacter === 'function') setCharacter(data)
    }
  } catch {
    // Si falla el refresh, usar el personaje en contexto
  }

  if (!characterNeedsStatsRealloc(char)) return true

  showStatsReallocBlocked(char, navigate)
  return false
}
